(function () {
  if (window.__stScriptsLoaded) return;
  window.__stScriptsLoaded = true;

  function stInitReveal() {
    const els = document.querySelectorAll('.st-reveal:not(.st-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('st-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            entry.target.style.setProperty('--st-i', i);
            entry.target.classList.add('st-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));

    // Red de seguridad: si por lo que sea el observer no dispara (pestaña en
    // segundo plano, navegador raro...), el contenido no debe quedarse invisible.
    setTimeout(() => {
      els.forEach((el) => el.classList.add('st-visible'));
      io.disconnect();
    }, 2500);
  }

  function stInitCifras() {
    const els = document.querySelectorAll('.st-cifra[data-hasta]:not([data-st-contado])');
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          io.unobserve(el);
          el.setAttribute('data-st-contado', 'true');
          const hasta = parseInt(el.dataset.hasta, 10) || 0;
          const dur = 1400;
          const t0 = performance.now();
          function tick(now) {
            const p = Math.min(1, (now - t0) / dur);
            el.textContent = Math.round(hasta * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach((el) => io.observe(el));
  }

  function stInitHistoriaTabs() {
    document.querySelectorAll('.st-historias:not([data-st-bound])').forEach((wrap) => {
      wrap.setAttribute('data-st-bound', 'true');
      const cards = wrap.querySelectorAll('.st-historia-card');
      cards.forEach((card) => {
        card.addEventListener('click', () => {
          cards.forEach((c) => c.classList.remove('st-historia-activa'));
          card.classList.add('st-historia-activa');
        });
      });
    });
  }

  function stInitGaleria() {
    document.querySelectorAll('[data-st-galeria]:not([data-st-bound])').forEach((wrap) => {
      wrap.setAttribute('data-st-bound', 'true');
      const principal = wrap.querySelector('.st-galeria-principal img');
      const minis = wrap.querySelectorAll('.st-galeria-mini');
      if (!principal || !minis.length) return;
      minis.forEach((mini) => {
        mini.addEventListener('click', () => {
          const src = mini.getAttribute('data-st-mini-src');
          if (src) principal.src = src;
          minis.forEach((m) => m.classList.remove('st-galeria-mini--activa'));
          mini.classList.add('st-galeria-mini--activa');
        });
      });
    });
  }

  function stInitVariantes() {
    document.querySelectorAll('[data-st-form]:not([data-st-bound])').forEach((form) => {
      form.setAttribute('data-st-bound', 'true');
      const variantesScript = form.querySelector('[data-st-variantes]');
      const variantInput = form.querySelector('[data-st-variant-input]');
      const boton = form.querySelector('[data-st-boton-comprar]');
      const botonTexto = form.querySelector('[data-st-boton-texto]');
      if (!variantesScript || !variantInput) return;

      let variantes = [];
      try {
        variantes = JSON.parse(variantesScript.textContent);
      } catch (e) {
        return;
      }

      const grupos = form.querySelectorAll('[data-st-opcion]');
      if (!grupos.length) return;

      function seleccionActual() {
        return Array.from(grupos).map((grupo) => {
          const activo = grupo.querySelector('.st-opcion-valor--activa');
          return activo ? activo.getAttribute('data-st-valor') : null;
        });
      }

      function encontrarVariante(valores) {
        return variantes.find((v) => {
          const opciones = [v.option1, v.option2, v.option3];
          return valores.every((val, i) => val === null || opciones[i] === val);
        });
      }

      function aplicarVariante(variante) {
        if (!variante) return;
        variantInput.value = variante.id;
        if (boton) {
          boton.disabled = !variante.available;
          if (botonTexto) {
            botonTexto.textContent = variante.available
              ? (boton.getAttribute('data-st-texto-disponible') || botonTexto.textContent)
              : (boton.getAttribute('data-st-texto-agotado') || 'Agotado');
          }
        }
      }

      if (boton && botonTexto && !boton.hasAttribute('data-st-texto-disponible')) {
        boton.setAttribute('data-st-texto-disponible', botonTexto.textContent.trim());
      }

      grupos.forEach((grupo) => {
        grupo.querySelectorAll('.st-opcion-valor').forEach((valor) => {
          valor.addEventListener('click', () => {
            grupo.querySelectorAll('.st-opcion-valor').forEach((v) => v.classList.remove('st-opcion-valor--activa'));
            valor.classList.add('st-opcion-valor--activa');
            const variante = encontrarVariante(seleccionActual());
            aplicarVariante(variante);
          });
        });
      });
    });
  }

  function stInitVideosInicio() {
    document.querySelectorAll('video[data-st-video-inicio]:not([data-st-bound])').forEach((v) => {
      v.dataset.stBound = 'true';
      const inicio = parseFloat(v.dataset.stVideoInicio) || 0;
      const fin = parseFloat(v.dataset.stVideoFin) || 0;
      if (inicio <= 0 && fin <= 0) return;
      v.removeAttribute('loop');
      const seekToInicio = () => {
        try { v.currentTime = inicio; } catch (e) {}
      };
      v.addEventListener('loadedmetadata', seekToInicio);
      if (v.readyState >= 1) seekToInicio();
      v.addEventListener('timeupdate', () => {
        const limite = fin > inicio ? fin : (v.duration || 0);
        if (limite && v.currentTime >= limite - 0.1) {
          v.currentTime = inicio;
          v.play().catch(() => {});
        }
      });
    });
  }

  // Videos diferidos: no se descargan hasta que se acercan a la pantalla
  // y se pausan al salir, para no gastar datos del celular.
  function stInitVideosDiferidos() {
    const videos = document.querySelectorAll('video[data-st-lazy-video]:not([data-st-lazy-bound])');
    if (!videos.length) return;
    const cargar = (v) => {
      if (!v.getAttribute('src') && v.dataset.stSrc) { v.src = v.dataset.stSrc; v.preload = 'auto'; v.load(); }
    };
    if (!('IntersectionObserver' in window)) { videos.forEach((v) => { cargar(v); v.play().catch(() => {}); }); return; }
    // 1) Precarga cuando el video está a ~600px de aparecer
    const precarga = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => { if (e.isIntersecting) { cargar(e.target); precarga.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    // 2) Reproduce cuando se ve y pausa cuando sale
    const juego = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        const v = e.target;
        if (e.isIntersecting) { cargar(v); const p = v.play(); if (p) p.catch(() => {}); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.2 });
    videos.forEach((v) => { v.dataset.stLazyBound = 'true'; v.muted = true; precarga.observe(v); juego.observe(v); });
  }

  function stInitTodo() {
    stInitReveal();
    stInitCifras();
    stInitHistoriaTabs();
    stInitGaleria();
    stInitVariantes();
    stInitVideosInicio();
    stInitVideosDiferidos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stInitTodo, { once: true });
  } else {
    stInitTodo();
  }

  // Re-escanea cuando el editor de temas añade/reordena secciones en vivo.
  document.addEventListener('shopify:section:load', stInitTodo);
})();
